module.exports = __webpack_public_path__ + "static/media/logo-pink.8441efd7.svg";